import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  srPrices: {
    id: 'learning.offer.screenReaderPrices', // historic id
    defaultMessage: 'Original price: {originalPrice}, discount price: {discountedPrice}',
  },
  srInlinePrices: {
    id: 'learning.upgradeButton.screenReaderInlinePrices',
    defaultMessage: 'Original price: {originalPrice}',
  },
  upgradeFor: {
    id: 'learning.upgradeButton.upgradeFor',
    defaultMessage: 'Get your Certificate {pricing}',
    description: 'Text used to describe the price of the upgrade',
  },
});

export default messages;
